import { Banner } from '../../../banner/Banner';

export function DiscardChangesConfirmModalBody() {
  return (
    <Banner open dataId='discard-modal-confirm-body' color='warning' icon='error-outline'>
      Any changes made till now will be lost
    </Banner>
  );
}
